const defaultCurrentFollowTabIndex = 0

const state = {
  currentFollowTabIndex: defaultCurrentFollowTabIndex
}

const getters = {}

const mutations = {
  SET_CURRENTFOLLOWTABINDEX: (state, payload) => {
    state.currentFollowTabIndex = payload
  }
}

const actions = {
  setCurrentFollowTabIndex({ commit }, currentTabIndex) {
    commit('SET_CURRENTFOLLOWTABINDEX', currentTabIndex)
  },
  clearCurrentFollowTabIndex({ commit }) {
    const defCurrentFollowTabIndex = 0
    commit('SET_CURRENTFOLLOWTABINDEX', defCurrentFollowTabIndex)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
